import { render, staticRenderFns } from "./TermsOfSale.vue?vue&type=template&id=c3052464&scoped=true"
import script from "./TermsOfSale.vue?vue&type=script&lang=js"
export * from "./TermsOfSale.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/legal.less?vue&type=style&index=0&id=c3052464&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3052464",
  null
  
)

export default component.exports